import * as KatalMetrics from '@amzn/katal-metrics';

export const MOUNT_TO_INTERACTIVE = 'MountToInteractive';
export const MOUNT_TO_INTERACTIVE_WHALE = 'MountToInteractive.Whale';
export const MOUNT_TO_INTERACTIVE_NON_WHALE = 'MountToInteractive.NonWhale';
export const MOUNT_TO_INTERACTIVE_ERROR = 'MountToInteractive.Error';
export const MOUNT_TO_INTERACTIVE_ERROR_LATENCY =
  'MountToInteractive.ErrorLatency';
export const ACCOUNT_DROPDOWN_PROVIDER_MOUNT_TO_INTERACTIVE =
  'AccountDropdownProviderMountToInteractive';
export const ACCOUNT_DROPDOWN_PROVIDER_MOUNT_TO_INTERACTIVE_WHALE =
  'AccountDropdownProviderMountToInteractive.Whale';
export const ACCOUNT_DROPDOWN_PROVIDER_MOUNT_TO_INTERACTIVE_NON_WHALE =
  'AccountDropdownProviderMountToInteractive.NonWhale';

/*
 * A failure has a duration but it is not a page-load latency, so it never reaches
 * the latency timers. Publishing it there made a fast failure read as a fast page
 * and hid a real regression behind a healthy p90. `isWhale` is optional because a
 * surface without a cursor has no whale population to split on, and inventing one
 * would report a dimension nothing measures.
 */
export type MountToInteractiveOutcome =
  | { failed: true; latencyMs: number }
  | { failed: false; latencyMs: number; isWhale?: boolean };

export const publishMountToInteractive = (
  publisher: KatalMetrics.Publisher,
  outcome: MountToInteractiveOutcome,
): void => {
  if (outcome.failed) {
    publisher.publishCounterMonitor(MOUNT_TO_INTERACTIVE_ERROR, 1);
    publisher.publishTimerMonitor(
      MOUNT_TO_INTERACTIVE_ERROR_LATENCY,
      outcome.latencyMs,
    );
    return;
  }

  publisher.publishCounterMonitor(MOUNT_TO_INTERACTIVE_ERROR, 0);
  publisher.publishTimerMonitor(MOUNT_TO_INTERACTIVE, outcome.latencyMs);
  if (outcome.isWhale !== undefined) {
    publisher.publishTimerMonitor(
      outcome.isWhale
        ? MOUNT_TO_INTERACTIVE_WHALE
        : MOUNT_TO_INTERACTIVE_NON_WHALE,
      outcome.latencyMs,
    );
  }
};

export const publishAccountDropdownProviderMountToInteractive = (
  publisher: KatalMetrics.Publisher,
  outcome: { latencyMs: number; isWhale: boolean },
): void => {
  publisher.publishTimerMonitor(
    ACCOUNT_DROPDOWN_PROVIDER_MOUNT_TO_INTERACTIVE,
    outcome.latencyMs,
  );
  publisher.publishTimerMonitor(
    outcome.isWhale
      ? ACCOUNT_DROPDOWN_PROVIDER_MOUNT_TO_INTERACTIVE_WHALE
      : ACCOUNT_DROPDOWN_PROVIDER_MOUNT_TO_INTERACTIVE_NON_WHALE,
    outcome.latencyMs,
  );
};
